import { render } from "./PlayerPointsGamesCard.vue?vue&type=template&id=bf975370&scoped=true"
import script from "./PlayerPointsGamesCard.vue?vue&type=script&lang=js"
export * from "./PlayerPointsGamesCard.vue?vue&type=script&lang=js"

import "./PlayerPointsGamesCard.vue?vue&type=style&index=0&id=bf975370&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf975370"]])

export default __exports__